import "./component.css"

$(() => {
  $('.expandable-item').on('click', (e) => {
    const item = $(e.currentTarget);
    item.find('.expanding-body').toggleClass('hidden');
    item.find('.faq_caret').toggleClass('rotate-180');
    })
});


// WEBPACK FOOTER //
// ./app/components/faqs/component.js